import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hash: localStorage.getItem('hash') || null,
    profile: null,
    snackbar: {
      text: null,
      show: false,
      color: "success",
    },
    refreshTick: new Date().getTime(),
  },
  mutations: {
      setHash(state,hash){
        state.hash = hash
        console.log('hash',hash)
        if (hash===null){
          state.profile=null
          localStorage.removeItem('hash')
        }else{
          localStorage.setItem('hash', hash)
        }
      },
      updateTick(state){
        state.refreshTick++
      },
      setProfile(state,profile){
        state.profile = profile
      },
      scankbarShow(state, { text, color = "success" }) {
        state.snackbar.show = true
        state.snackbar.text = text
        state.snackbar.color = color
      },
  },
  getters: {
    
  },
  actions: {
  },
  modules: {
  }
})
